module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('link', {
    attrs: {
      "href": "styles/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('title', [_vm._v("The Angel\nAnswer Book")]), _vm._v(" "), _c('p', {
    staticClass: "ser1",
    attrs: {
      "id": "pAX7"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images/img-5-1.jpg",
      "id": "AX7",
      "src": "images/img-5-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ct",
    attrs: {
      "id": "pAi2"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#007467"
    }
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pAo"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter02#aa_2",
      "id": "bb_2"
    }
  }, [_vm._v("\nIntroduction "), _c('i', [_vm._v("All Night, All Day")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "pAO"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/part01#aap_1",
      "id": "bbp_1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#007467"
    }
  }, [_vm._v("Holy Angels")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "pAP"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/part02#aap_2",
      "id": "bbp_2"
    }
  }, [_vm._v("\nWHAT THE BIBLE SAYS ABOUT ANGELS ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pAqb"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter03#aa_3",
      "id": "bb_3"
    }
  }, [_vm._v("\nWhat are angels?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pAMD"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter04#aa_4",
      "id": "bb_4"
    }
  }, [_vm._v("\nDo angels really exist?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pAtX"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter05#aa_5",
      "id": "bb_5"
    }
  }, [_vm._v("\nWhat is the best true source for learning about angels?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pA0"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter06#aa_6",
      "id": "bb_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nWhy is the Bible our only accurate source of information about angels?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pA8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter07#aa_7",
      "id": "bb_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nHow are angels portrayed in the Bible?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pA9k"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter08#aa_8",
      "id": "bb_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nWhat are some biblical examples of God using His angels to accomplish His will?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pADi"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter09#aa_9",
      "id": "bb_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nWhat do angels look like?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pA0c"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10#aa_10",
      "id": "bb_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nWe view angels as supernatural beings, but how does God view them?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pAgi"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter11#aa_11",
      "id": "bb_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nWhat are some stories in the Bible that tell us about angelic activity?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pAi7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter12#aa_12",
      "id": "bb_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nAngels were alive and active during Bible times, but what about today?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pA8n"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter13#aa_13",
      "id": "bb_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nWhat is the best verse in the Bible about angels?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "AsL"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter14#aa_14",
      "id": "bb_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nWho are angels subject to?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "ANk"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter15#aa_15",
      "id": "bb_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nAre angels invisible?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pAQZ"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter16#aa_16",
      "id": "bb_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nWhat does the Bible mean by the phrase “ministering spirits”?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pAd8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter17#aa_17",
      "id": "bb_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nExactly how do angels serve those who inherit salvation?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pA-"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter18#aa_18",
      "id": "bb_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nWhat is an example of present-day angel activity?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "pASI"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/part03#aap_3",
      "id": "bbp_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nTHE ORIGIN AND OCCUPATION OF ANGELS ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pAbN"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter19#aa_19",
      "id": "bb_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nWhat does the Bible say about the origin of angels?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pA4y"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter20#aa_20",
      "id": "bb_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nWhat is the occupation of angels?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "A9h"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter21#aa_21",
      "id": "bb_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nHow do angels travel?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "ADC"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter22#aa_22",
      "id": "bb_22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nDo angels ride horses while patrolling the earth?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pAZB"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter23#aa_23",
      "id": "bb_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nWhat are some of the biblical terms used to describe angels?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pAa6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter24#aa_24",
      "id": "bb_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nDo angelic armies surround us?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "AYj"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter25#aa_25",
      "id": "bb_25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nDo angels have paranormal powers?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pAeb"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter26#aa_26",
      "id": "bb_26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nDo angels really watch over us?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "ADQ"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter27#aa_27",
      "id": "bb_27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nHow many angels are there?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "pA_Q"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/part04#aap_4",
      "id": "bbp_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nTHE POWERS AND PERSONALITIES OF ANGELS ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "Aqp"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter28#aa_28",
      "id": "bb_28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nDo angels have names and personalities?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "A2l"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter28a#aa_28a",
      "id": "bb_28a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nIs it okay to worship angels?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "ASG"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter29#aa_29",
      "id": "bb_29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nWhat do angels have in common with Christians?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "A1k"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter30#aa_30",
      "id": "bb_30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nWhat is my favorite angel story in the Bible?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "pAN6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/part05#aap_5",
      "id": "bbp_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nANGELS IN THE LIFE OF CHRIST ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pAhB"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter31#aa_31",
      "id": "bb_31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nIn what seven great epochs in the story of Christ are angels prominent players?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "pAb4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/part06#aap_6",
      "id": "bbp_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nANGELS WATCHING OVER ME ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pAnV"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter32#aa_32",
      "id": "bb_32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nWhat does the term "), _c('i', [_vm._v("Mahanaim")]), _vm._v(" mean, and what does it have to do with angels?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pAmx"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter33#aa_33",
      "id": "bb_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nDo angels take care of other physical needs besides our safety?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pA15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter33a#aa_33a",
      "id": "bb_33a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nWhat are other ways angels bless us?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "pAZC"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/part07#aap_7",
      "id": "bbp_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nANGELS DELIVER US FROM JUDGMENT ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pAIt"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter34#aa_34",
      "id": "bb_34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nWhat do angels have to do with God’s wrath and judgment?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pA5C"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter35#aa_35",
      "id": "bb_35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nWhat role do angels play in dispensing God’s judgment on sin-hardened individuals\nand\nsociety?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pA4g"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter36#aa_36",
      "id": "bb_36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nDo angels deliver us from God’s judgment?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "ATx"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter37#aa_37",
      "id": "bb_37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nDo angels appear to animals?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pAI_"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter38#aa_38",
      "id": "bb_38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nWhat is an example of a current-day rescue made by angels?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pAH9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter39#aa_39",
      "id": "bb_39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nWhat is one of the most famous angelic rescues in biblical times?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pAVq"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter40#aa_40",
      "id": "bb_40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nWhy is it important for us to fear and obey the Lord if we want angelic assistance\nin\nour\nlives?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pAmf"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter41#aa_41",
      "id": "bb_41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nWhat is an easy verse to recall when in an emergency situation?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pACs"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter42#aa_42",
      "id": "bb_42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nWhy don’t angels always save us from harm?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "AKG"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter43#aa_43",
      "id": "bb_43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nDo we each have our own guardian angel?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pAFa"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter44#aa_44",
      "id": "bb_44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nCan you describe an event when someone’s guardian angel or angels seem to have made\nan\nappearance?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "pAk3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/part08#aap_8",
      "id": "bbp_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nANGELS ASSIST GOD IN ANSWERING OUR PRAYERS ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pAX1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter45#aa_45",
      "id": "bb_45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nDo angels assist God in answering our personal prayers?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pASV"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter46#aa_46",
      "id": "bb_46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nDo angels face resistance when delivering answers to our prayers?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pAvp"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter47#aa_47",
      "id": "bb_47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nIf angels deliver answers to our prayers, why not simply pray to them?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pAme"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter48#aa_48",
      "id": "bb_48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nIs there an example of how angels might be mobilized in modern times to assist God\nin\nanswering\nprayer?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pAhs"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter49#aa_49",
      "id": "bb_49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nDo angels sing?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "ADf"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter50#aa_50",
      "id": "bb_50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nWho are seraphim?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "AMk"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter51#aa_51",
      "id": "bb_51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nWho are cherubim?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pAWr"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter52#aa_52",
      "id": "bb_52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nWhy are there so many cherubim in the tabernacle and the temple?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pAVh"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter53#aa_53",
      "id": "bb_53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nHow will angels be involved in the second coming of Christ?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "pA0_"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/part09#aap_9",
      "id": "bbp_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nANGELS USHER US TO HEAVEN ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pA6J"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter54#aa_54",
      "id": "bb_54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nDo angels usher us to heaven when we die?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pAjd"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter55#aa_55",
      "id": "bb_55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nAre there other biblical examples of angels escorting people to heaven at the end\nof\ntheir\nearthly lives?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pAYx"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter56#aa_56",
      "id": "bb_56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nWhat about when Jesus returns? What will the angels do then?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pA0Ll"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter57#aa_57",
      "id": "bb_57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nHow can I best prepare for the time when my earthly life will draw to a close?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "pAkt"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/part10#aap_10",
      "id": "bbp_10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#007467"
    }
  }, [_vm._v("Fallen Angels")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "pAvX"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/part11#aap_11",
      "id": "bbp_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nTHE ORIGIN OF EVIL ANGELS ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pApj"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter58#aa_58",
      "id": "bb_58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nIs Satan an angelic being? Did the Devil, or Satan, start out as a created angel?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pARm"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter59#aa_59",
      "id": "bb_59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nWho is Lucifer?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "AQB"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter60#aa_60",
      "id": "bb_60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nHow is Lucifer described in Isaiah 14?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "AOx"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter61#aa_61",
      "id": "bb_61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nWhat caused Lucifer’s rebellion?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "A6M"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter62#aa_62",
      "id": "bb_62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nWhat was God’s reaction to Lucifer’s rebellion?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "AeV"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter63#aa_63",
      "id": "bb_63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nWhen did the original rebellion happen?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pAN5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter64#aa_64",
      "id": "bb_64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nTurning to the parallel passage in Ezekiel 28, how is Lucifer described?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pAk2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter65#aa_65",
      "id": "bb_65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nIs Lucifer specifically referred to as an angel in Ezekiel 28?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pAr0"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter66#aa_66",
      "id": "bb_66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nWhat ruined all this?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pAOy"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter67#aa_67",
      "id": "bb_67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nWhat happened when God detected evil in Lucifer’s heart?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pAAU"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter68#aa_68",
      "id": "bb_68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nDid any of the angelic hosts follow Lucifer in his rebellion against God?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pAi_"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter69#aa_69",
      "id": "bb_69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nWhat other passages in the Bible speak of fallen angels?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pA9Xz"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter70#aa_70",
      "id": "bb_70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nIs Satan the opposite of God?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "ABR"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter71#aa_71",
      "id": "bb_71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nHow does Satan attack God’s children?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "ACK"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter72#aa_72",
      "id": "bb_72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nWhat else did the apostle Paul say about Satan?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pAH1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter73#aa_73",
      "id": "bb_73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nWhere are Satan’s fallen angels right now?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "A_p"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter74#aa_74",
      "id": "bb_74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nAre all the fallen angels currently in the Abyss?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "pAHs"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/part12#aap_12",
      "id": "bbp_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nDEMON POSSESSION AND POWERS ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pAYVJ"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter75#aa_75",
      "id": "bb_75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nDoes the presence of demons help explain the intensity of evil on earth?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pAbR"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter76#aa_76",
      "id": "bb_76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nWas Adolf Hitler demon possessed?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "AoN"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter77#aa_77",
      "id": "bb_77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nWhy did Hitler hate the Jews so much?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pAqV"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter78#aa_78",
      "id": "bb_78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nThe Bible indicates people can be possessed by demons, but can an individual be possessed\nby\nthe\nDevil himself?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pAgZ"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter79#aa_79",
      "id": "bb_79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nWhat are the characteristics of demon possession or demonic influence?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pA9C"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter80#aa_80",
      "id": "bb_80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nWhat happened to Legion and his demons in the Gospels?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pATHq"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter81#aa_81",
      "id": "bb_81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nAre there other examples of animals being possessed by demons?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pAyu"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter82#aa_82",
      "id": "bb_82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nDo demonic powers operate on a geopolitical level as well as a personal level?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pA64"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter83#aa_83",
      "id": "bb_83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nCan demonic powers affect our prayers?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "ACX"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter84#aa_84",
      "id": "bb_84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nCan Christians be demon possessed?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pAxx"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter85#aa_85",
      "id": "bb_85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nHow did the apostle Paul respond to demon possession?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pA0g"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter86#aa_86",
      "id": "bb_86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nCan demons and those with demons predict the future?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pAXYJ"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter87#aa_87",
      "id": "bb_87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nIs it okay to read horoscopes, consult Ouija boards and tarot cards, and sometimes\nvisit\nfortune-tellers?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pAmZ"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter88#aa_88",
      "id": "bb_88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nWhat should our attitude be toward the occult—witchcraft, fortune-telling, astrology,\nnecromancy,\nand\nthe like?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pAau"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter89#aa_89",
      "id": "bb_89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nShould we be afraid of demons?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pAcT"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter90#aa_90",
      "id": "bb_90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nWhat did the great reformer Martin Luther have to say about the Devil?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pAcR"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter91#aa_91",
      "id": "bb_91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nHow should we respond when Satan and his demonic forces threaten to undo us?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pAqyU"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter92#aa_92",
      "id": "bb_92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nHas our victory over Satan’s forces of evil already been won by Christ?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pACs-"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter93#aa_93",
      "id": "bb_93",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nHow do I appropriate the blood of Christ for my own forgiveness and protection?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pAch"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter94#aa_94",
      "id": "bb_94",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nHaving become a Christian, am I now immune to Satan’s temptations?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pAnY"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter95#aa_95",
      "id": "bb_95",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nAs a Christian, how do I respond to satanic temptations and demonic attacks?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pAR1P"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter96#aa_96",
      "id": "bb_96",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nAre there some particular verses I should memorize on this subject?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pAVe"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter97#aa_97",
      "id": "bb_97",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nHow do we resist the Devil?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pArO"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter98#aa_98",
      "id": "bb_98",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nHow is the Word of God like a sword we can use against Satan?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pAE8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter99#aa_99",
      "id": "bb_99",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nCan I rebuke the Devil?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pAy4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter100#aa_100",
      "id": "bb_100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nIs it possible to become too obsessed over Satan?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "Ayb"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter101#aa_101",
      "id": "bb_101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nCan fallen angels read our minds?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "pA5CV"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/part13#aap_13",
      "id": "bbp_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nSATAN AND FALLEN ANGELS IN THE LAST DAYS ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pAd5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter102#aa_102",
      "id": "bb_102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nWhat role do Satan and the fallen angels play in the last days?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pAqqT"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter103#aa_103",
      "id": "bb_103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nWhat happens to fallen angels during the Tribulation?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pAGy"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter104#aa_104",
      "id": "bb_104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nAre there yet more demons in the Abyss who will escape or be released during the\nTribulation?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pAIs"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter105#aa_105",
      "id": "bb_105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nWho will provide the face of leadership on the earth during the Great Tribulation?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pAJe"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter106#aa_106",
      "id": "bb_106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nWhat will be the final result of the Antichrist?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pAfg"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter107#aa_107",
      "id": "bb_107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nWhat then will happen to Satan and all the fallen angels upon Christ’s return?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pALk"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter108#aa_108",
      "id": "bb_108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nWhat is the central message about fallen angels in the book of Revelation?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pAIX"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter109#aa_109",
      "id": "bb_109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nWhat is the summarization of all this?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "A4e"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter110#aa_110",
      "id": "bb_110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nAny more advice about angels and demons?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pA4Q"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter111#aa_111",
      "id": "bb_111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\nWhat in the Bible is most surprising about good and evil angels?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pA6k"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter112#aa_112",
      "id": "bb_112",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Conclusion")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter112a#aa_112a",
      "id": "bb_112a",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Endnotes")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f1d30c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 63
// module chunks = 0